/**
 * Shared constants for the send-recommended-notification-editor feature.
 * Extracted from blueconic/constants.ts so both BlueConic and Vespa
 * can use the same ID ordering scheme.
 */

export const INDEX_DISPLAY_DEFAULT_ID = {
    0: 'first',
    1: 'second',
    2: 'third',
    3: 'fourth',
    4: 'fifth',
    5: 'sixth',
}
